import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UrlRedirectToken } from '@sleed/bizcommerce-api';
import { urlRedirectsApi } from '~/lib/api/client';
import { formToToken, type UrlRedirectFormValues } from '~/lib/schemas/url-redirect';

export const urlRedirectKeys = { all: ['url-redirects'] as const, list: () => [...urlRedirectKeys.all, 'list'] as const };

export function useUrlRedirectsList() {
	return useQuery<UrlRedirectToken[]>({
		queryKey: urlRedirectKeys.list(),
		queryFn: async () => (await urlRedirectsApi.getAll()).data.items ?? []
	});
}

export function useUrlRedirectMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: urlRedirectKeys.list() });
	const create = useMutation({
		mutationFn: async (form: UrlRedirectFormValues) => (await urlRedirectsApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: UrlRedirectFormValues) => (await urlRedirectsApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await urlRedirectsApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
